import axios from "axios";

// In development, use localhost. In production, use relative path
const isDevelopment = process.env.NODE_ENV === "development";
const API_URL = isDevelopment ? "http://localhost:3002/api" : "/api";

// Public endpoint - no token needed, only returns published blogs
export const getBlogs = async (token = null) => {
  try {
    const config = {
      headers: {},
    };

    // If token is provided, add it to headers (for admin access)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios.get(`${API_URL}/blogs`, config);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error fetching blogs:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};

// Get single blog - public access
export const getBlog = async (blogId) => {
  try {
    const response = await axios.get(`${API_URL}/blogs/${blogId}`);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error fetching blog:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};

// Admin-only functions below - require authentication
export const createBlog = async (blogData, token) => {
  try {
    const response = await axios.post(`${API_URL}/blogs`, blogData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error creating blog:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};

export const updateBlog = async (blogId, blogData, token) => {
  try {
    const response = await axios.put(`${API_URL}/blogs/${blogId}`, blogData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error updating blog:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};

export const deleteBlog = async (blogId, token) => {
  try {
    const response = await axios.delete(`${API_URL}/blogs/${blogId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error deleting blog:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};

export const reorderBlogs = async (blogOrders, token) => {
  try {
    const response = await axios.put(
      `${API_URL}/blogs/reorder`,
      { blogOrders },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error reordering blogs:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};
